import React from 'react';
import { useLabels } from 'ws-scripts/modules/common';

/**
 * SearchInput — visual-only search field rendered inside the drawer.
 * No form submission or PubSub integration; purely decorative placeholder.
 *
 * @returns {React.ReactElement}
 */
const SearchInput = () => {
	const labels = useLabels();
	// Widget UI label — not from nav service response.
	// Nav-item text comes pre-resolved from the navigation service.
	const placeholder = labels.get('SEARCH_THE_WHOLE_SITE');

	return (
		<div
			className="ws-nav-drawer__search-input d-flex align-items-center align-self-stretch m-4 py-3 px-4"
			data-testid="drawer-search-input"
		>
			<input
				type="text"
				className="ws-nav-drawer__search-input-field p-0 mr-4 ddc-font-size-large"
				placeholder={placeholder}
				aria-label={placeholder}
			/>
			<span
				className="ddc-icon ddc-icon-search-thin ws-nav-drawer__search-input-icon ddc-font-size-xlarge"
				data-testid="drawer-search-icon"
				aria-hidden="true"
			/>
		</div>
	);
};

export default SearchInput;
